<template>
  <ion-modal :is-open="updateAvailable" backdrop-dismiss="false">
    <ion-card class="update-modal">
      <ion-card-header>
        <ion-card-title>{{ $t('newVersion') }}</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <p>
            {{  $t('newVersionText1') }} (<strong>{{ latestVersion }}</strong>).
            {{  $t('newVersionText2') }}
        </p>
        <ion-button expand="block" color="primary" @click="openStore">
            {{  $t('updateNow') }} 
        </ion-button>
      </ion-card-content>
    </ion-card>
  </ion-modal>
</template>

<script>
import { ref, onMounted, onUnmounted, version, computed, watch, watchEffect } from 'vue'
import { App } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'
import semver from 'semver'
import { IonModal, IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonButton } from '@ionic/vue'
import getAndroidStoreVersionQueryFile from '../graphql/getAndroidStoreVersion.query.gql'
import { useQuery } from '@vue/apollo-composable'

// --- OPTION: iOS Store Info abrufen ---
async function fetchIOSVersion(appId) {
  try {
    const res = await fetch(`https://itunes.apple.com/lookup?id=${appId}`)
    const json = await res.json()
    return json.results?.[0]?.version || null
  } catch (err) {
    console.warn('[UpdateChecker] Fehler beim Abruf der iOS-Version:', err)
    return null
  }
}

// --- OPTION: Play Store Version abrufen ---
async function fetchAndroidVersion(packageName) {
  try {
    
    return version

    /*const details = await gplay.app({ appId: 'de.smartup.CLUBINONE4U', lang: 'de', country: 'de' })
    console.log(details.version)
    return details.version*/

    /*const res = await fetch(`https://play.google.com/store/apps/details?id=${packageName}&hl=de&gl=DE`, { mode: 'no-cors' })
    console.log("🚀 ~ fetchAndroidVersion ~ res:", res[0])
    const html = await res.text()
    console.log("🚀 ~ fetchAndroidVersion ~ html:", html)
    const match = html.match(/<div[^>]*>([0-9]+\.[0-9]+\.[0-9]+)<\/div>/)
    return match ? match[1] : null*/
  } catch (err) {
    console.warn('[UpdateChecker] Fehler beim Abruf der Android-Version:', err)
    return null
  }
}

export default {
  name: 'UpdateChecker',
  components: { IonModal, IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonButton },

  setup() {
    const updateAvailable = ref(false)
    const latestVersion = ref(null)
    let listener = null

    const { result: getAndroidStoreVersionResult, loading } = useQuery(getAndroidStoreVersionQueryFile, null, { fetchPolicy: 'no-cache', enabled: Capacitor.getPlatform() == 'android' })
    //console.log("🚀 ~ setup ~ getAndroidStoreVersion:", getAndroidStoreVersion)
    const AndroidVersion = computed(() => getAndroidStoreVersionResult.value?.getAndroidStoreVersion?.version ?? '1.0')

    async function checkForUpdate(AndroidVersion) {
      try {
        const { version } = await App.getInfo()
        const platform = Capacitor.getPlatform()

        let storeVersion = null
        if (platform === 'ios') {
          storeVersion = await fetchIOSVersion('1616499691') // Beispiel: 1234567890
        } else if (platform === 'android') {
          storeVersion = AndroidVersion
        }

        if (storeVersion && semver.lt(semver.coerce(version), semver.coerce(storeVersion))) {
          latestVersion.value = storeVersion
          updateAvailable.value = true
        }
      } catch (err) {
        //console.log('[UpdateChecker] Fehler beim Versionscheck:', err)
      }
    }

    async function openStore() {
      const platform = Capacitor.getPlatform()
      if (platform === 'ios') {
        window.open('https://apps.apple.com/app/1616499691', '_system')
      } else if (platform === 'android') {
        window.open('https://play.google.com/store/apps/details?id=de.smartup.CLUBINONE4U', '_system')
      }
      updateAvailable.value = false
    }

    watch(AndroidVersion, async (newVal) => {
        if (!loading.value && newVal !== '1.0') {
          const platform = Capacitor.getPlatform()

          if (platform === 'web') {
            updateAvailable.value = false
            latestVersion.value = '1.3.0'
          } else {
            await checkForUpdate(newVal)
          }
        }
      },
      { immediate: true }
    )

    onMounted(async () => {
      //await checkForUpdate()
      listener = await App.addListener('appStateChange', async ({ isActive }) => {
        if (isActive && !loading.value) await checkForUpdate(AndroidVersion.value)
      })
    })

    onUnmounted(() => {
      if (listener) listener.remove()
    })

    return { updateAvailable, latestVersion, openStore }
  }
}
</script>

<style scoped>

.update-modal::part(content) {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  --background: transparent;
}

.modal-content-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

ion-modal {
  --backdrop-opacity: 0.6;
}
ion-card {
  max-width: 90%;
  margin: auto;
  text-align: center;
}
</style>
